import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitorStatisticExportComponent } from './component/visitor-statistic-export.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { DictionaryModule, MaterialModule, ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { StructureNodeSelectionModule } from 'src/tmc-yard/components/structure-node-selection/structure-node-selection.module';

@NgModule({
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    MatTableModule,
    MatSortModule,
    ReactiveFormsModule,
    FormsModule,
    StructureNodeSelectionModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  declarations: [VisitorStatisticExportComponent]
})
export class VisitorStatisticExportModule { }
